export default __webpack_public_path__ + "static/media/ShadowyCave.954a004f.jpg";